import script from "./TargetPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TargetPanel.vue?vue&type=script&lang=ts&setup=true"

import "./TargetPanel.vue?vue&type=style&index=0&id=440b470b&lang=css"

const __exports__ = script;

export default __exports__